<script>
    import { onMount } from 'svelte';

    export let box_amount = 1;
	export let height = 240;
	export let margin_bottom = 15;

    let boxes = null;

    onMount(async () => {
        boxes = Array(box_amount);
	});
</script>

{#if boxes != null}
    {#each boxes as foo}
    <div class="waiting-placeholder-box" style="height: {height}px; margin-bottom: {margin_bottom}px;"></div>
    {/each}
{/if}

<style>
.waiting-placeholder-box{
	background: var(--medium-color);
	width: 100%;

	animation-duration: 4s;
	animation-name: fadein;
	animation-iteration-count: infinite;
}


@keyframes fadein {
	0% {
		opacity: 0;
	}

	25% {
		opacity: 1;
	}

	50% {
		opacity: 0;
	}

	75% {
		opacity: 1;
	}
  
	100% {
		opacity: 0;
	}
}
</style>